var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02 1L7.02 3.38C6.82 3.44 6.64 3.54 6.46 3.64L4.08 2.64L2.64 4.08L3.64 6.46C3.54 6.66 3.46 6.82 3.38 7.02L1 8.02V10.02L3.38 11.02C3.46 11.22 3.54 11.38 3.64 11.58L2.64 13.96L4.08 15.4L6.46 14.4C6.64 14.48 6.82 14.58 7.02 14.66L8.02 17.04H10.02L11.02 14.66C11.2 14.58 11.4 14.5 11.58 14.4L13.96 15.4L15.4 13.96L14.4 11.58C14.48 11.4 14.58 11.2 14.66 11.02L17.04 10.02V8.02L14.66 7.02C14.6 6.84 14.5 6.64 14.4 6.46L15.4 4.08L13.96 2.64L11.58 3.64C11.4 3.56 11.2 3.46 11.02 3.38L10.02 1H8.02ZM9.02 6C10.68 6 12.02 7.34 12.02 9C12.02 10.66 10.68 12 9.02 12C7.36 12 6.02 10.66 6.02 9C6.02 7.34 7.36 6 9.02 6Z",
    fill: "#654B78"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1647_41370",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 17,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.02 1L7.02 3.38C6.82 3.44 6.64 3.54 6.46 3.64L4.08 2.64L2.64 4.08L3.64 6.46C3.54 6.66 3.46 6.82 3.38 7.02L1 8.02V10.02L3.38 11.02C3.46 11.22 3.54 11.38 3.64 11.58L2.64 13.96L4.08 15.4L6.46 14.4C6.64 14.48 6.82 14.58 7.02 14.66L8.02 17.04H10.02L11.02 14.66C11.2 14.58 11.4 14.5 11.58 14.4L13.96 15.4L15.4 13.96L14.4 11.58C14.48 11.4 14.58 11.2 14.66 11.02L17.04 10.02V8.02L14.66 7.02C14.6 6.84 14.5 6.64 14.4 6.46L15.4 4.08L13.96 2.64L11.58 3.64C11.4 3.56 11.2 3.46 11.02 3.38L10.02 1H8.02ZM9.02 6C10.68 6 12.02 7.34 12.02 9C12.02 10.66 10.68 12 9.02 12C7.36 12 6.02 10.66 6.02 9C6.02 7.34 7.36 6 9.02 6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1647_41370)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.16e32040c5a6625ff37a3e1c61e1dca4.svg";
export { ForwardRef as ReactComponent };